module.exports = __webpack_public_path__ + "img/11.16334983.png";